import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html'
})
export class EmployeeComponent implements OnInit {
  @ViewChild('addDataModal') public addDataModal: ModalDirective;
  @ViewChild('deleteDataModal') public deleteDataModal: ModalDirective;
  @ViewChild('updateDataModal') public updateDataModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  public gridApi;
  private gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];
  public states;

  public rowClassRules;

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ]
  dataList = [];
  departments = [];
  newForm = {
    employee_id: "",
    full_name: "",
    phone_no: "",
    work_location: "",
    designation: "",
    salary: "",
    email_id: "",
    father_name: "",
    mother_name: "",
    permanent_address: "",
    temporary_address: "",
    date_of_birth: "",
    date_of_joining: "",
    qualification: "",
    location: "",
    aadhar_no: "",
    pan_no: "",
    bank_account_no: "",
    bank_name: "",
    ifsc_code: "",
    esi_no: "",
    nominee: "",
    epf_no: "",
    nearest_epf_hospital: "",
    uan_no: "",
    phone_no_2: "",
    state: "",
    project: "",
    status: "active",
    status_update_on: moment().format('YYYY-MM-DD'),
    // document_attached: "",
    // attachments: ""
  }
  requiredFields = ['full_name', 'phone_no', 'father_name', 'permanent_address', 'date_of_birth'];

  excludedFieldInUpdates: any = ['document_attached', 'attachments', 'app_device', 'device_id'];

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService:  ConstantService, private apiService: ApiService, private http: HttpClient) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:0,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent
    };
    this.states = this.constantService.getDataConstant('states');
    console.log(this.states);

    this.rowClassRules = {
      // apply green to 2008
      'rag-red-outer': (params) => { return params.data.status === 'inactive'; },
  };
    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 80, filter: false,}
    ];
    _.each(_.keys(this.newForm), (field) => {
      this.columnDefs.push({ headerName: this.convertLabel(field), field: field, width: 120 })
    })


    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false,cellClass: ['text-center'], pinned: 'right'  },
      )
    }
   }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listData();
    this.listProject();
    let document_list: any = [];
    let docList = this.constantService.getDataConstant('document_list');

    _.each(_.keys(docList), (item) => {
      document_list.push({ item_id: item, item_text: docList[item] })
    })
    this.dropdownList = document_list;
  }
  listData() {
    this.apiService.getData('employees').then((resp: []) => {
      this.dataList = resp;
    })
  }
  projectList: any = [];
  listProject() {
    this.apiService.getData('project').then((resp: []) => {
      this.projectList = resp;
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.moveColumn('project', 2);
  }
  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'edit') {
      this.newForm = _.clone(this.selectedData);
      delete this.newForm['srl_no'];
      delete this.newForm['action'];
      let docList = this.constantService.getDataConstant('document_list');
      // if (this.newForm.document_attached) {
      //   let selectedList = this.newForm.document_attached.split(',');
      //   console.log(selectedList);
      //   let document_list: any = [];
      //   _.each(selectedList, (item) => {

      //     document_list.push({ item_id: item, item_text: docList[item] })
      //   })
      //   this.selectedItems = document_list;
      //   console.log(document_list);
      // }

      this.updateDataModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteDataModal.show();
    }


  }

  savenewForm() {
    // this.newForm.document_attached = ((this.selectedItems).map(item => item.item_id)).join(',');

    let duplicateRecord = this.checkForDuplicates(this.newForm);
    if(duplicateRecord) {
      this.alert.type = 'danger';
      this.alert.msg = 'Data already saved';
      setTimeout(() => {
        this.addDataModal.hide();
      this.alert.type = '';
        this.alert.msg = '';
      }, 2000)
    } else {

      this.apiService.addData('employees', this.newForm).subscribe((resp) => {
        console.log(resp);
        this.createUser();
        this.uploadFile();
        this.resetForm();
        this.listData();
        this.alert.msg = 'Data has been successfully created.';
        setTimeout(() => {
          this.addDataModal.hide();
          this.alert.msg = '';
        }, 2000)
      })

    }


  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newForm = {
      employee_id: "",
      full_name: "",
      phone_no: "",
      work_location: "",
      designation: "",
      salary: "",
      email_id: "",
      father_name: "",
      mother_name: "",
      permanent_address: "",
      temporary_address: "",
      date_of_birth: "",
      date_of_joining: "",
      qualification: "",
      location: "",
      aadhar_no: "",
      pan_no: "",
      bank_account_no: "",
      bank_name: "",
      ifsc_code: "",
      esi_no: "",
      nominee: "",
      epf_no: "",
      nearest_epf_hospital: "",
      uan_no: "",
      phone_no_2: "",
      state: "",
      project: "",
      status: "active",
      status_update_on: moment().format('YYYY-MM-DD'),
      // document_attached: "",
      // attachments: ""
    }
  }

  updateProfile() {
    let that = this;
    // this.newForm.document_attached = ((this.selectedItems).map(item => item.item_id)).join(',');
    this.apiService.updateDetail('employees', 'srl_no', this.selectedData.srl_no, this.newForm).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listData();
      that.uploadFile();
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.updateDataModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  checkForDuplicates(data) {
    let filterData = _.filter(this.dataList, (item) => {
      return (item.phone_no).trim() === (data.phone_no).trim();
    })
    console.log(filterData);
    if (filterData.length > 0) {
      return filterData[0];
    } else {
      return null;
    }

  }

  convertLabel(label: string) {
    return label.replace(/_/g, ' ').toUpperCase();
  }


  formData  = new FormData();
  fileChange(index,event) {

    const fileList: FileList = event.target.files;
    //check whether file is selected or not
    if (fileList.length > 0) {

        const file = fileList[0];
        //get file information such as name, size and type
        console.log('finfo',file.name,file.size,file.type);
        //max file size is 4 mb
        if((file.size/1048576)<=4)
        {
          // this.newForm.attachments = this.newForm.phone_no + '_document.pdf'
          // this.formData.append('file', file, this.newForm.attachments);
        }else{
          //this.snackBar.open('File size exceeds 4 MB. Please choose less than 4 MB','',{duration: 2000});
        }

    }

  }



  deleteData() {
    this.apiService.deleteDetail('employees', 'srl_no', [this.selectedData.srl_no]).subscribe((resp) => {
      this.listData();
      this.apiService.deleteDetail('users', 'username', [this.selectedData.phone_no]).subscribe((r) => {
      })
      setTimeout(() => {
        this.deleteDataModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }


  uploadFile() {
    this.http.post('https://e-attendance-mahaboudh.in/api/api/uploadPdf.php', this.formData).subscribe((response) => {
      console.log(response);
    })
  }


  createUser() {
    let payload = {
      fullName: this.newForm.full_name,
      contactNo: this.newForm.phone_no,
      userType: 'staff',
      permission: 'rwm',
      username: this.newForm.phone_no,
      password: btoa('user@'+this.newForm.phone_no.slice(this.newForm.phone_no.length - 4))
    };
    this.apiService.addData('users', payload).subscribe((resp) => {
    })
  }

}
